import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService, MediaService } from '@frontend/common';
import { ApplicationService } from '../../utilities/application.service';

import { User } from '@frontend/common';
import { MainNavigationLink } from '@frontend/common';

@Component({
  selector: 'multisite-account-home',
  templateUrl: './account-home.component.html',
  styleUrls: ['./account-home.component.scss'],

  standalone: false,
})
export class AccountHomeComponent implements OnInit, OnDestroy {


  user: User = null;
  userSubscription;
  isAuthenticated: boolean = false;
  loading = false;
  error = null;
  navigationLinks: MainNavigationLink[];

  constructor(
    private authService: AuthService,
    private mediaService: MediaService,
    private applicationService: ApplicationService,
  ) { 
    this.navigationLinks = [
      // TODO: investigate why Angular treats routerLinkValue: ['password'] as a primitive string, not as an array of strings
      {labelText: null, labelLanguageKey : 'authentication.password', routerLinkValue: ['password'], condition: ''},
      {labelText: null, labelLanguageKey : 'common.email_address', routerLinkValue: ['email'], condition: ''},
      {labelText: null, labelLanguageKey : 'navigation.notifications', routerLinkValue: ['notifications'], condition: ''},
      {labelText: null, labelLanguageKey: 'account.subscriptions.title', labelTranslationScope: 'account', routerLinkValue: ['subscriptions'], condition: ''},
      {labelText: null, labelLanguageKey : 'account.consent', routerLinkValue: ['consent'], condition: ''},
    ];
  }
  getDefaultAvatar (){
    return this.mediaService._fallback_avatar_url;
  }

  changeEmail (newEmail: string){
    this.loading = true;
    this.authService.changeEmail(newEmail).subscribe(
      () => {
        this.loading = false;
      },
      errorMessage => {
        this.loading = false;
        this.error = errorMessage == 'authentication.already_registered_log_in' ? 'authentication.already_registered' : errorMessage;
      });
  };

  ngOnInit() {
    this.userSubscription = this.authService.user.subscribe(
      (user) => {
        this.user = user;
      },
      (error) => {
        this.error = error;
      }
    );
    this.authService.getUser(true).subscribe(); // gets the full editable version, with email address  
  }

  ngOnDestroy() {
    this.userSubscription.unsubscribe();
  }

}
